/**
 * تبدیل داده‌های مارکر قدیمی به فرمت استاندارد NeshanMapView
 * @param {Array} data
 * @param {string} actionTitle
 * @returns {import("../maps/NeshanMapView").MapMarkerData[]}
 */
export const toMapMarkerData = (data = [], actionTitle = "") => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map(({ location, name, id, icon, description, color }) => ({
    location,
    name,
    id,
    icon,
    description,
    color,
    actionTitle: actionTitle || undefined,
  }));
};

export default toMapMarkerData;
